//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vip_box from '../_value_analysis/vip_box'
import page_mixins from '../_value_analysis/mixins'
import house_data from '../_value_analysis/house_data'
import facility_data from '../_value_analysis/facility_data'
import VaPage from '../_value_analysis/page'
import CommonFooter from '../_value_analysis/_footer'
import ExcellentConsultants from '../_components/_excellent_consultants'
import vip_pop_box_mixins from '@/common/tpl/vip/mixins'
import VipPopBox from '@/common/tpl/vip/_vip_pop_box'
import get_float_questions from '@/common/tpl/aqr_questions/get_float_questions'
import check_scrolling from '@/common/tpl/mixins/check_scrolling'
import PopModal from '@/components/views/_pop_modal'
export default {
    data() {
        return {
            building_id: '',
        }
    },
    mixins: [
        page_mixins,
        vip_box,
        house_data,
        facility_data,
        check_scrolling,
        get_float_questions,
        vip_pop_box_mixins
    ],
    async mounted() {
        const {building_id} = this.$route.query
        this.building_id = building_id
        this.refreshData()
    },
    methods: {
        joinGroup() {
            const link = "https://mp.weixin.qq.com/s/2n2XCJLQU1wmoA99hOPcoA"
            wx.navigateTo({
                url: `/building/discuess_group/main`
            })
        },
        becomeVipSucess() {
            this.hideVipPopBox()
            this.refreshData()
        },
        async refreshData() {
            await this.getBuilding(this.building_id)
            this.getData(this.building_id)
            this.getExcellentConsultant(this.building_id)
            this.getFloatQuestions('楼盘详情-价值分析报告')
        }
    },
    components: {
        CommonFooter,
        VipPopBox,
        VaPage,
        ExcellentConsultants,
        PopModal
    }
}
